import api, { ResponsePayloadWithData } from '../../../api';

export type Note = {
  id: string;
  nodeId: string;
  note: string;
  createdAt: string;
  updatedAt: string;
};

export const getNotes = async (moduleId: string, nodeId: string) => {
  const { data } = await api.get<ResponsePayloadWithData<Note[]>>(
    `/studio/user/modules/${moduleId}/table-of-content/${nodeId}/notes`,
  );

  return data;
};
